import { LogWriter } from '../writers/LogWriter';

export const isWriterEnabled = async (writer: LogWriter): Promise<boolean> => {
  try {
    return await writer.isEnabled();
  } catch {
    return Promise.resolve(false);
  }
};
